import { PartialSite, Site, SitePreviewError } from "../models/site";
import axiosConfig from "./axiosConfig";

const postPreviewSite = async (
  authToken: string,
  payload: PartialSite
): Promise<{ site: Site } & { errors?: SitePreviewError[] }> => {
  const { data } = await axiosConfig.post(`/site/preview`, payload, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postPreviewSite;
